import {combineReducers} from 'redux';

import login from './pages/user/login';
import verification from './pages/user/verification';
import profile from './pages/user/profile';
import products from './pages/products';
import modalAddToStock from './partials/modals/modalAddToStock';
import modalEditFromStock from './partials/modals/modalEditFromStock';
import orders from './pages/orders';
import editOrder from './pages/orders/edit';

import trans from './pages/trans';
import addTrans from './pages/trans/addTrans';
import userAuthentication from './pages/trans/userAuthentication';
import accumulative from './pages/trans/accumulative';
import settlements from './pages/trans/settlements';
import installmentsFactor from './pages/installments_factor';
import modalTransDetails from './partials/modals/modalTransDetails';
import modalEditTransFactorNum from './partials/modals/modalEditTransFactorNum';
import modalRejectFactor from './partials/modals/modalRejectFactor';
import allLoaders from './loaders';
import custom_snackbar from './snackbar';

export default combineReducers({
    login,
    verification,
    profile,
    products,
    modalAddToStock,
    modalEditFromStock,
    orders,
    editOrder,
    
    trans,
    addTrans,
    userAuthentication,
    accumulative,
    settlements,
    installmentsFactor,
    modalTransDetails,
    modalEditTransFactorNum,
    modalRejectFactor,
    allLoaders,
    custom_snackbar,
});
